export default __webpack_public_path__ + "static/media/CleanShot 2021-11-28 at 19.59 4.gif.e2e7fdd6.mp4";